import { useState, useEffect } from "react";
// import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = ({ Auth }) => {
  const [selectedNomina, setSelectedNomina] = useState(null);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null); // nuevo


  return ( 
  <div className="layout-container layout-slim p-ripple-disabled layout-light ">
      <Sidebar />
      <div className="navbar">
        <Navbar
          Auth={Auth}
          selectedNomina={selectedNomina}
          setSelectedNomina={setSelectedNomina}
        />
      </div>
      <div className="main-content layout-content-wrapper ">
        <div className="layout-content p-4">
          <Outlet
            context={{
              selectedNomina,
              empleadoSeleccionado,
              setEmpleadoSeleccionado,
            }}
          />
        </div>
      </div>
      </div>
  );
};

export default Layout;
